module.exports = __webpack_public_path__ + "img/bd-fireclaws-dru.e55169b6.png";